import { FC } from "react";
import { StepId } from "../onboardingSteps";
import { PanelProps } from "./types";
import WelcomePanel from "./WelcomePanel";
import IdentityPanel from "./IdentityPanel";
import ContractPanel from "./ContractPanel";
import ArrivalPanel from "./ArrivalPanel";
import InventoryPanel from "./InventoryPanel";
import InsurancePanel from "./InsurancePanel";
import HomePanel from "./HomePanel";

/**
 * Which panel fills the centre column for a given step. Keyed by StepId, so
 * adding a step to the journey is a compile error until its panel exists.
 */
export const STEP_PANELS: Record<StepId, FC<PanelProps>> = {
  welcome: WelcomePanel,
  identity: IdentityPanel,
  contract: ContractPanel,
  arrival: ArrivalPanel,
  inventory: InventoryPanel,
  insurance: InsurancePanel,
  home: HomePanel,
};

export type { PanelProps };
